import categoriesApi from "../../api/categories";

const state = () => ({
  queried: false,
  categories: []
});

const getters = {
  all: state => () => state.categories,
  byId: state => categoryId => state.categories.find(v => v._id === categoryId)
};

const actions = {
  fetchAll({ commit }) {
    return new Promise((resolve, reject) => {
      if (state.queried) {
        resolve();
      } else {
        categoriesApi
          .getAll()
          .then(categories => {
            commit("setCategories", categories);
            resolve();
          })
          .catch(e => reject(e));
      }
    });
  }
};

const mutations = {
  setCategories(state, categories) {
    state.queried = true;
    state.categories = categories;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
